import 'semantic-ui-less/semantic.less';
import React, { memo } from 'react';
import { LayoutProvider } from 'src/components/layout/LayoutContext';
import Page from './Page';

interface LayoutProps {
    children: React.ReactNode;
    pageContext: any;
}

const Layout = ({ children, pageContext }: LayoutProps) => {
    return (
        <LayoutProvider>
            <Page pageContext={pageContext} children={children} />
        </LayoutProvider>
    );
};

export default memo(Layout);
